export default "__VITE_ASSET__BrbhCQ7I__"